import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Lookup } from 'src/app/app.types';

@Component({
    selector: 'custom-multi-select',
    templateUrl: './custom-multi-select.component.html',
    styleUrls: ['./custom-multi-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomMultiSelectComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class CustomMultiSelectComponent implements ControlValueAccessor {
  @Input() itemType = "Items";
  @Input() items: Lookup[] = [];
  selectedItems: Lookup[] = [];
  isDropdownOpen = false;
    
  private onChange!: (value: Lookup[]) => void;
  private onTouched!: () => void;

  writeValue(obj: Lookup[]): void {
    this.selectedItems = obj;
  }
  
  registerOnChange(fn: (value: Lookup[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  selectItem(item: Lookup) {
    if(this.selectedItems.some(x => x.id === item.id)){
      this.selectedItems = this.selectedItems.filter(x => x.id !== item.id);
    } else {
      this.selectedItems.push(item);
    }

    this.onChange(this.selectedItems);
  }

  isItemSelected = (item: Lookup) => this.selectedItems.some(x => x.id === item.id);

  getLabel() {
    const selectedCount = this.selectedItems.length;
    return selectedCount === this.items.length ? `All ${this.itemType}` : `${this.itemType} [${selectedCount}]`;
  }
}
